/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Interviews & Questions
 * OpenAPI спецификация для управления собеседованиями и вопросами. Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BaseQuestionFields
 */
export interface BaseQuestionFields {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof BaseQuestionFields
     */
    'text'?: string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof BaseQuestionFields
     */
    'order'?: number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof BaseQuestionFields
     */
    'isRequired'?: boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof BaseQuestionFields
     */
    'evaluationCriteria'?: string;
}
/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InterviewAnswer
 */
export interface InterviewAnswer {
    /**
     * ID ответа
     * @type {number}
     * @memberof InterviewAnswer
     */
    'id': number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof InterviewAnswer
     */
    'questionText'?: string;
    /**
     * Текст ответа (транскрибация)
     * @type {string}
     * @memberof InterviewAnswer
     */
    'answerText'?: string;
    /**
     * URL аудио файла ответа
     * @type {string}
     * @memberof InterviewAnswer
     */
    'audioUrl'?: string;
    /**
     * Балл за ответ 1-10
     * @type {number}
     * @memberof InterviewAnswer
     */
    'score'?: number;
    /**
     * Обоснование оценки
     * @type {string}
     * @memberof InterviewAnswer
     */
    'scoreJustification'?: string;
    /**
     * Обратная связь по ответу
     * @type {string}
     * @memberof InterviewAnswer
     */
    'feedback'?: string;
    /**
     * Длительность ответа в секундах
     * @type {number}
     * @memberof InterviewAnswer
     */
    'durationSeconds'?: number;
    /**
     * Время создания ответа
     * @type {string}
     * @memberof InterviewAnswer
     */
    'createdAt': string;
}
/**
 * Ответ с ответами собеседования и агрегированными итоговыми полями
 * @export
 * @interface InterviewAnswersOverviewResponse
 */
export interface InterviewAnswersOverviewResponse {
    /**
     * Список ответов собеседования
     * @type {Array<InterviewAnswer>}
     * @memberof InterviewAnswersOverviewResponse
     */
    'answers'?: Array<InterviewAnswer>;
    /**
     * Итоговая оценка интервью 0–10
     * @type {number}
     * @memberof InterviewAnswersOverviewResponse
     */
    'overallScore'?: number;
    /**
     * Итоговый текстовый вывод по собеседованию
     * @type {string}
     * @memberof InterviewAnswersOverviewResponse
     */
    'overallSummary'?: string;
}
/**
 * 
 * @export
 * @interface InterviewCreateRequest
 */
export interface InterviewCreateRequest {
    /**
     * ID вакансии
     * @type {number}
     * @memberof InterviewCreateRequest
     */
    'positionId': number;
    /**
     * Email кандидата
     * @type {string}
     * @memberof InterviewCreateRequest
     */
    'candidateEmail': string;
    /**
     * Имя кандидата (если новый)
     * @type {string}
     * @memberof InterviewCreateRequest
     */
    'firstName'?: string;
    /**
     * Фамилия кандидата (если новый)
     * @type {string}
     * @memberof InterviewCreateRequest
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface InterviewListItem
 */
export interface InterviewListItem {
    /**
     * ID собеседования
     * @type {number}
     * @memberof InterviewListItem
     */
    'id': number;
    /**
     * ID вакансии
     * @type {number}
     * @memberof InterviewListItem
     */
    'positionId': number;
    /**
     * ID кандидата
     * @type {number}
     * @memberof InterviewListItem
     */
    'candidateId': number;
    /**
     * Email кандидата
     * @type {string}
     * @memberof InterviewListItem
     */
    'candidateEmail'?: string;
    /**
     * Имя кандидата
     * @type {string}
     * @memberof InterviewListItem
     */
    'candidateFirstName'?: string;
    /**
     * Фамилия кандидата
     * @type {string}
     * @memberof InterviewListItem
     */
    'candidateLastName'?: string;
    /**
     * 
     * @type {InterviewStatusEnum}
     * @memberof InterviewListItem
     */
    'status': InterviewStatusEnum;
    /**
     * 
     * @type {InterviewResultEnum}
     * @memberof InterviewListItem
     */
    'result'?: InterviewResultEnum;
    /**
     * Общий балл собеседования
     * @type {number}
     * @memberof InterviewListItem
     */
    'score'?: number;
    /**
     * Время начала собеседования
     * @type {string}
     * @memberof InterviewListItem
     */
    'startedAt'?: string;
    /**
     * Время завершения собеседования
     * @type {string}
     * @memberof InterviewListItem
     */
    'finishedAt'?: string;
    /**
     * Время создания записи
     * @type {string}
     * @memberof InterviewListItem
     */
    'createdAt': string;
    /**
     * Время последнего обновления
     * @type {string}
     * @memberof InterviewListItem
     */
    'updatedAt': string;
    /**
     * 
     * @type {InterviewSourceEnum}
     * @memberof InterviewListItem
     */
    'source'?: InterviewSourceEnum;
    /**
     * 
     * @type {PriorCommunication}
     * @memberof InterviewListItem
     */
    'priorCommunication'?: PriorCommunication;
}


/**
 * Результат собеседования
 * @export
 * @enum {string}
 */

export const InterviewResultEnum = {
    SUCCESSFUL: 'SUCCESSFUL',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
    ERROR: 'ERROR'
} as const;

export type InterviewResultEnum = typeof InterviewResultEnum[keyof typeof InterviewResultEnum];


/**
 * Настройки проведения интервью для вакансии. Все поля являются опциональными - обновляются только переданные значения. 
 * @export
 * @interface InterviewSettingsUpdate
 */
export interface InterviewSettingsUpdate {
    /**
     * Нужная оценка для получения успешного интервью 
     * @type {number}
     * @memberof InterviewSettingsUpdate
     */
    'minScore'?: number;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof InterviewSettingsUpdate
     */
    'level'?: PositionLevelEnum;
    /**
     * Разделы PDF-отчёта AI-скрининга (JUSTIFICATION, CRITERIA_DETAILS, STRENGTHS, RECOMMENDATIONS, TRANSCRIPT). Пустой список — ни одного раздела. 
     * @type {Array<string>}
     * @memberof InterviewSettingsUpdate
     */
    'pdfReportSections'?: Array<string>;
    /**
     * Время ответа на вопрос в секундах. Минимальное значение: 30, максимальное: 600. 
     * @type {number}
     * @memberof InterviewSettingsUpdate
     */
    'answerTime'?: number;
    /**
     * Язык проведения интервью. Поддерживаемые значения: ru, en. 
     * @type {string}
     * @memberof InterviewSettingsUpdate
     */
    'language'?: string;
    /**
     * Показывать вопросы на других языках помимо основного. Полезно для международных компаний. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'showOtherLang'?: boolean;
    /**
     * Случайный порядок вопросов при проведении интервью. Помогает избежать списывания и стандартизации ответов. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'randomOrder'?: boolean;
    /**
     * Сохранять аудио ответы кандидатов. Требует дополнительного места на диске. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'saveAudio'?: boolean;
    /**
     * Сохранять видео ответы кандидатов. Требует значительного места на диске. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'saveVideo'?: boolean;
}


/**
 * Поля для сортировки собеседований.  **Временные поля:** - `createdAt` - время создания - `startedAt` - время начала - `updatedAt` - время обновления - `finishedAt` - время завершения  **Поля кандидата:** - `candidate.firstName` - имя кандидата - `candidate.lastName` - фамилия кандидата - `candidate.email` - email кандидата  **Поля интервью:** - `status` - статус собеседования - `result` - результат собеседования - `score` - оценка AI  **Примеры сортировки:** - `createdAt,desc` - по времени создания (новые сначала) - `startedAt,asc` - по времени начала (ранние сначала) - `candidate.firstName,asc` - по имени кандидата (А-Я) - `score,desc` - по оценке (высокие сначала) 
 * @export
 * @interface InterviewSortFields
 */
export interface InterviewSortFields {
    /**
     * Поле для сортировки
     * @type {string}
     * @memberof InterviewSortFields
     */
    'field'?: InterviewSortFieldsField;
    /**
     * Направление сортировки
     * @type {string}
     * @memberof InterviewSortFields
     */
    'direction'?: InterviewSortFieldsDirection;
}

export const InterviewSortFieldsField = {
    CREATED_AT: 'createdAt',
    STARTED_AT: 'startedAt',
    UPDATED_AT: 'updatedAt',
    FINISHED_AT: 'finishedAt',
    CANDIDATE_FIRST_NAME: 'candidate.firstName',
    CANDIDATE_LAST_NAME: 'candidate.lastName',
    CANDIDATE_EMAIL: 'candidate.email',
    STATUS: 'status',
    RESULT: 'result',
    SCORE: 'score'
} as const;

export type InterviewSortFieldsField = typeof InterviewSortFieldsField[keyof typeof InterviewSortFieldsField];
export const InterviewSortFieldsDirection = {
    ASC: 'asc',
    DESC: 'desc'
} as const;

export type InterviewSortFieldsDirection = typeof InterviewSortFieldsDirection[keyof typeof InterviewSortFieldsDirection];

/**
 * Источник интервью. MANUAL — создано рекрутером вручную. RESPONSES — кандидат пришёл через отклики (Отклики). 
 * @export
 * @enum {string}
 */

export const InterviewSourceEnum = {
    MANUAL: 'MANUAL',
    RESPONSES: 'RESPONSES'
} as const;

export type InterviewSourceEnum = typeof InterviewSourceEnum[keyof typeof InterviewSourceEnum];


/**
 * Статус запуска интервью
 * @export
 * @enum {string}
 */

export const InterviewStartStatusEnum = {
    STARTED: 'STARTED',
    ERROR: 'ERROR'
} as const;

export type InterviewStartStatusEnum = typeof InterviewStartStatusEnum[keyof typeof InterviewStartStatusEnum];


/**
 * Статус собеседования
 * @export
 * @enum {string}
 */

export const InterviewStatusEnum = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED',
    LIMIT_EXHAUSTED: 'LIMIT_EXHAUSTED'
} as const;

export type InterviewStatusEnum = typeof InterviewStatusEnum[keyof typeof InterviewStatusEnum];


/**
 * Пагинированный список интервью
 * @export
 * @interface InterviewsPaginatedResponse
 */
export interface InterviewsPaginatedResponse {
    /**
     * Список собеседований
     * @type {Array<InterviewListItem>}
     * @memberof InterviewsPaginatedResponse
     */
    'content': Array<InterviewListItem>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof InterviewsPaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof InterviewsPaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы
     * @type {number}
     * @memberof InterviewsPaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof InterviewsPaginatedResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface ListPositionQuestions200Response
 */
export interface ListPositionQuestions200Response {
    /**
     * 
     * @type {Array<Question>}
     * @memberof ListPositionQuestions200Response
     */
    'content': Array<Question>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof ListPositionQuestions200Response
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof ListPositionQuestions200Response
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof ListPositionQuestions200Response
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof ListPositionQuestions200Response
     */
    'size': number;
}
/**
 * Базовый класс для всех пагинированных ответов
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Список элементов на текущей странице
     * @type {Array<object>}
     * @memberof PaginatedResponse
     */
    'content': Array<object>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof PaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof PaginatedResponse
     */
    'size': number;
}
/**
 * Уровень вакансии
 * @export
 * @enum {string}
 */

export const PositionLevelEnum = {
    JUNIOR: 'JUNIOR',
    MIDDLE: 'MIDDLE',
    SENIOR: 'SENIOR',
    LEAD: 'LEAD'
} as const;

export type PositionLevelEnum = typeof PositionLevelEnum[keyof typeof PositionLevelEnum];


/**
 * Информация о предыдущем общении с кандидатом в рамках компании (есть другое интервью с тем же email на другой вакансии). 
 * @export
 * @interface PriorCommunication
 */
export interface PriorCommunication {
    /**
     * ID предыдущей вакансии
     * @type {number}
     * @memberof PriorCommunication
     */
    'positionId': number;
    /**
     * Название предыдущей вакансии
     * @type {string}
     * @memberof PriorCommunication
     */
    'positionTitle'?: string;
    /**
     * Внутренняя метка предыдущей вакансии
     * @type {string}
     * @memberof PriorCommunication
     */
    'internalTag'?: string;
    /**
     * Имя рекрутера, создавшего предыдущее интервью
     * @type {string}
     * @memberof PriorCommunication
     */
    'recruiterFirstName'?: string;
    /**
     * Фамилия рекрутера, создавшего предыдущее интервью
     * @type {string}
     * @memberof PriorCommunication
     */
    'recruiterLastName'?: string;
    /**
     * Дата создания предыдущего интервью
     * @type {string}
     * @memberof PriorCommunication
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * ID вопроса
     * @type {number}
     * @memberof Question
     */
    'id': number;
    /**
     * ID вакансии
     * @type {number}
     * @memberof Question
     */
    'positionId': number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof Question
     */
    'text': string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof Question
     */
    'order': number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof Question
     */
    'isRequired': boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof Question
     */
    'evaluationCriteria'?: string;
    /**
     * Длительность аудиофайла в секундах
     * @type {number}
     * @memberof Question
     */
    'voiceDurationSec'?: number;
    /**
     * Время создания
     * @type {string}
     * @memberof Question
     */
    'createdAt': string;
    /**
     * Время последнего обновления
     * @type {string}
     * @memberof Question
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface QuestionCreateRequest
 */
export interface QuestionCreateRequest {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof QuestionCreateRequest
     */
    'text': string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof QuestionCreateRequest
     */
    'order': number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof QuestionCreateRequest
     */
    'isRequired'?: boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof QuestionCreateRequest
     */
    'evaluationCriteria'?: string;
}
/**
 * Запрос на регенерацию вопроса с использованием ИИ. Уровень кандидата определяет сложность генерируемого вопроса. 
 * @export
 * @interface QuestionRegenerateRequest
 */
export interface QuestionRegenerateRequest {
    /**
     * Причина регенерации вопроса. Помогает ИИ понять контекст и сгенерировать более подходящий вопрос. 
     * @type {string}
     * @memberof QuestionRegenerateRequest
     */
    'regenerateReason'?: string;
    /**
     * Сохранить контекст предыдущего вопроса при регенерации. Если true, ИИ будет учитывать тематику и сложность исходного вопроса. 
     * @type {boolean}
     * @memberof QuestionRegenerateRequest
     */
    'keepContext'?: boolean;
    /**
     * Дополнительный промпт для ИИ с конкретными требованиями к новому вопросу (тема, сложность, тип). 
     * @type {string}
     * @memberof QuestionRegenerateRequest
     */
    'aiPrompt'?: string;
}
/**
 * 
 * @export
 * @interface QuestionUpdateRequest
 */
export interface QuestionUpdateRequest {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof QuestionUpdateRequest
     */
    'text'?: string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof QuestionUpdateRequest
     */
    'order'?: number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof QuestionUpdateRequest
     */
    'isRequired'?: boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof QuestionUpdateRequest
     */
    'evaluationCriteria'?: string;
    /**
     * ID существующего вопроса для обновления. Отсутствует для нового вопроса
     * @type {number}
     * @memberof QuestionUpdateRequest
     */
    'id'?: number;
}
/**
 * Пагинированный список вопросов
 * @export
 * @interface QuestionsPaginatedResponse
 */
export interface QuestionsPaginatedResponse {
    /**
     * 
     * @type {Array<Question>}
     * @memberof QuestionsPaginatedResponse
     */
    'content'?: Array<Question>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof QuestionsPaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof QuestionsPaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof QuestionsPaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof QuestionsPaginatedResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface UpdateUiStatusRequest
 */
export interface UpdateUiStatusRequest {
    /**
     * UI-статус (scheduled, in-progress, successful, failed, error)
     * @type {string}
     * @memberof UpdateUiStatusRequest
     */
    'status': UpdateUiStatusRequestStatus;
}

export const UpdateUiStatusRequestStatus = {
    SCHEDULED: 'scheduled',
    IN_PROGRESS: 'in-progress',
    SUCCESSFUL: 'successful',
    FAILED: 'failed',
    ERROR: 'error'
} as const;

export type UpdateUiStatusRequestStatus = typeof UpdateUiStatusRequestStatus[keyof typeof UpdateUiStatusRequestStatus];


/**
 * InterviewsApi - axios parameter creator
 * @export
 */
export const InterviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Создать собеседование для вакансии своей компании. Ищет кандидата по email, при отсутствии создаёт нового кандидата и создаёт интервью со статусом NOT_STARTED. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать собеседование по email кандидата
         * @param {InterviewCreateRequest} interviewCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterview: async (interviewCreateRequest: InterviewCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewCreateRequest' is not null or undefined
            assertParamExists('createInterview', 'interviewCreateRequest', interviewCreateRequest)
            const localVarPath = `/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interviewCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить детальную информацию о собеседовании своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить информацию о собеседовании
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInterview', 'id', id)
            const localVarPath = `/interviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить все ответы кандидата на вопросы собеседования
         * @summary Получить ответы собеседования
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewAnswers: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInterviewAnswers', 'id', id)
            const localVarPath = `/interviews/{id}/answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Принимает UI-статус и маппит его на поля Interview.status / Interview.result. Поддерживаемые значения: scheduled, in-progress, successful, failed, error. 
         * @summary Обновить статус интервью через UI-статус (PATCH)
         * @param {number} id ID собеседования
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewsIdUiStatusPatch: async (id: number, updateUiStatusRequest: UpdateUiStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('interviewsIdUiStatusPatch', 'id', id)
            // verify required parameter 'updateUiStatusRequest' is not null or undefined
            assertParamExists('interviewsIdUiStatusPatch', 'updateUiStatusRequest', updateUiStatusRequest)
            const localVarPath = `/interviews/{id}/ui-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUiStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список собеседований своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список всех собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterviews: async (positionId?: number, candidateId?: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список всех собеседований для указанной вакансии с возможностью фильтрации и пагинации. Вакансия и кандидат не включаются в ответ.
         * @summary Список собеседований по вакансии
         * @param {number} positionId ID вакансии
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionInterviews: async (positionId: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('listPositionInterviews', 'positionId', positionId)
            const localVarPath = `/positions/{positionId}/interviews`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Алиас для PATCH, принимает тот же body.
         * @summary Обновить статус интервью через UI-статус (POST)
         * @param {number} id 
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterviewUiStatusPost: async (id: number, updateUiStatusRequest: UpdateUiStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInterviewUiStatusPost', 'id', id)
            // verify required parameter 'updateUiStatusRequest' is not null or undefined
            assertParamExists('updateInterviewUiStatusPost', 'updateUiStatusRequest', updateUiStatusRequest)
            const localVarPath = `/interviews/{id}/ui-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUiStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewsApi - functional programming interface
 * @export
 */
export const InterviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * Создать собеседование для вакансии своей компании. Ищет кандидата по email, при отсутствии создаёт нового кандидата и создаёт интервью со статусом NOT_STARTED. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать собеседование по email кандидата
         * @param {InterviewCreateRequest} interviewCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterview(interviewCreateRequest: InterviewCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterview(interviewCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.createInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить детальную информацию о собеседовании своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить информацию о собеседовании
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterview(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.getInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить все ответы кандидата на вопросы собеседования
         * @summary Получить ответы собеседования
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewAnswers(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewAnswersOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewAnswers(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.getInterviewAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Принимает UI-статус и маппит его на поля Interview.status / Interview.result. Поддерживаемые значения: scheduled, in-progress, successful, failed, error. 
         * @summary Обновить статус интервью через UI-статус (PATCH)
         * @param {number} id ID собеседования
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewsIdUiStatusPatch(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewsIdUiStatusPatch(id, updateUiStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.interviewsIdUiStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список собеседований своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список всех собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterviews(positionId?: number, candidateId?: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewsPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterviews(positionId, candidateId, status, result, search, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.listInterviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список всех собеседований для указанной вакансии с возможностью фильтрации и пагинации. Вакансия и кандидат не включаются в ответ.
         * @summary Список собеседований по вакансии
         * @param {number} positionId ID вакансии
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositionInterviews(positionId: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewsPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositionInterviews(positionId, status, result, search, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.listPositionInterviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Алиас для PATCH, принимает тот же body.
         * @summary Обновить статус интервью через UI-статус (POST)
         * @param {number} id 
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInterviewUiStatusPost(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInterviewUiStatusPost(id, updateUiStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewsApi.updateInterviewUiStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterviewsApi - factory interface
 * @export
 */
export const InterviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewsApiFp(configuration)
    return {
        /**
         * Создать собеседование для вакансии своей компании. Ищет кандидата по email, при отсутствии создаёт нового кандидата и создаёт интервью со статусом NOT_STARTED. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать собеседование по email кандидата
         * @param {InterviewCreateRequest} interviewCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterview(interviewCreateRequest: InterviewCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewListItem> {
            return localVarFp.createInterview(interviewCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить детальную информацию о собеседовании своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить информацию о собеседовании
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview(id: number, options?: RawAxiosRequestConfig): AxiosPromise<InterviewListItem> {
            return localVarFp.getInterview(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить все ответы кандидата на вопросы собеседования
         * @summary Получить ответы собеседования
         * @param {number} id ID собеседования
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewAnswers(id: number, options?: RawAxiosRequestConfig): AxiosPromise<InterviewAnswersOverviewResponse> {
            return localVarFp.getInterviewAnswers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Принимает UI-статус и маппит его на поля Interview.status / Interview.result. Поддерживаемые значения: scheduled, in-progress, successful, failed, error. 
         * @summary Обновить статус интервью через UI-статус (PATCH)
         * @param {number} id ID собеседования
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewsIdUiStatusPatch(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewListItem> {
            return localVarFp.interviewsIdUiStatusPatch(id, updateUiStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список собеседований своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список всех собеседований
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [candidateId] Фильтр по ID кандидата
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterviews(positionId?: number, candidateId?: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<InterviewsPaginatedResponse> {
            return localVarFp.listInterviews(positionId, candidateId, status, result, search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список всех собеседований для указанной вакансии с возможностью фильтрации и пагинации. Вакансия и кандидат не включаются в ответ.
         * @summary Список собеседований по вакансии
         * @param {number} positionId ID вакансии
         * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
         * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
         * @param {string} [search] Поиск по имени, фамилии, email кандидата
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionInterviews(positionId: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<InterviewsPaginatedResponse> {
            return localVarFp.listPositionInterviews(positionId, status, result, search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Алиас для PATCH, принимает тот же body.
         * @summary Обновить статус интервью через UI-статус (POST)
         * @param {number} id 
         * @param {UpdateUiStatusRequest} updateUiStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterviewUiStatusPost(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewListItem> {
            return localVarFp.updateInterviewUiStatusPost(id, updateUiStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterviewsApi - object-oriented interface
 * @export
 * @class InterviewsApi
 * @extends {BaseAPI}
 */
export class InterviewsApi extends BaseAPI {
    /**
     * Создать собеседование для вакансии своей компании. Ищет кандидата по email, при отсутствии создаёт нового кандидата и создаёт интервью со статусом NOT_STARTED. Изоляция данных происходит автоматически через JWT токен.
     * @summary Создать собеседование по email кандидата
     * @param {InterviewCreateRequest} interviewCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public createInterview(interviewCreateRequest: InterviewCreateRequest, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).createInterview(interviewCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить детальную информацию о собеседовании своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить информацию о собеседовании
     * @param {number} id ID собеседования
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public getInterview(id: number, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).getInterview(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить все ответы кандидата на вопросы собеседования
     * @summary Получить ответы собеседования
     * @param {number} id ID собеседования
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public getInterviewAnswers(id: number, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).getInterviewAnswers(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Принимает UI-статус и маппит его на поля Interview.status / Interview.result. Поддерживаемые значения: scheduled, in-progress, successful, failed, error. 
     * @summary Обновить статус интервью через UI-статус (PATCH)
     * @param {number} id ID собеседования
     * @param {UpdateUiStatusRequest} updateUiStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public interviewsIdUiStatusPatch(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).interviewsIdUiStatusPatch(id, updateUiStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список собеседований своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить список всех собеседований
     * @param {number} [positionId] Фильтр по ID вакансии
     * @param {number} [candidateId] Фильтр по ID кандидата
     * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
     * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
     * @param {string} [search] Поиск по названию вакансии, имени, фамилии, email кандидата
     * @param {number} [page] Номер страницы (начиная с 0)
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public listInterviews(positionId?: number, candidateId?: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).listInterviews(positionId, candidateId, status, result, search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список всех собеседований для указанной вакансии с возможностью фильтрации и пагинации. Вакансия и кандидат не включаются в ответ.
     * @summary Список собеседований по вакансии
     * @param {number} positionId ID вакансии
     * @param {InterviewStatusEnum} [status] Фильтр по статусу собеседования
     * @param {InterviewResultEnum} [result] Фильтр по результату собеседования
     * @param {string} [search] Поиск по имени, фамилии, email кандидата
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Сортировка в формате \&quot;поле,направление\&quot; (createdAt,desc, startedAt,asc, candidate.firstName,asc, status,asc, result,asc, score,desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public listPositionInterviews(positionId: number, status?: InterviewStatusEnum, result?: InterviewResultEnum, search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).listPositionInterviews(positionId, status, result, search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Алиас для PATCH, принимает тот же body.
     * @summary Обновить статус интервью через UI-статус (POST)
     * @param {number} id 
     * @param {UpdateUiStatusRequest} updateUiStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public updateInterviewUiStatusPost(id: number, updateUiStatusRequest: UpdateUiStatusRequest, options?: RawAxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).updateInterviewUiStatusPost(id, updateUiStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionsApi - axios parameter creator
 * @export
 */
export const QuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Создает новый вопрос для указанной вакансии
         * @summary Добавить вопрос к вакансии
         * @param {number} positionId ID вакансии
         * @param {QuestionCreateRequest} questionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPositionQuestion: async (positionId: number, questionCreateRequest: QuestionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('createPositionQuestion', 'positionId', positionId)
            // verify required parameter 'questionCreateRequest' is not null or undefined
            assertParamExists('createPositionQuestion', 'questionCreateRequest', questionCreateRequest)
            const localVarPath = `/positions/{positionId}/questions`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удаляет вопрос из системы
         * @summary Удалить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuestion', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает список всех вопросов в системе с пагинацией
         * @summary Получить список всех вопросов
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllQuestions: async (page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить детальную информацию о вопросе
         * @summary Получить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestion', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список всех вопросов для указанной вакансии
         * @summary Список вопросов по вакансии
         * @param {number} positionId ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionQuestions: async (positionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('listPositionQuestions', 'positionId', positionId)
            const localVarPath = `/positions/{positionId}/questions`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Регенерирует конкретный вопрос вакансии с использованием ИИ. Уровень кандидата определяет сложность и типы генерируемых вопросов. Передает в нейросеть ВСЕ поля вакансии для полного контекста. 
         * @summary Регенерировать один вопрос
         * @param {number} positionId ID вакансии
         * @param {number} questionId ID вопроса для регенерации
         * @param {QuestionRegenerateRequest} questionRegenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneratePositionQuestion: async (positionId: number, questionId: number, questionRegenerateRequest: QuestionRegenerateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('regeneratePositionQuestion', 'positionId', positionId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('regeneratePositionQuestion', 'questionId', questionId)
            // verify required parameter 'questionRegenerateRequest' is not null or undefined
            assertParamExists('regeneratePositionQuestion', 'questionRegenerateRequest', questionRegenerateRequest)
            const localVarPath = `/positions/{positionId}/questions/{questionId}/regenerate`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionRegenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет существующий вопрос
         * @summary Обновить вопрос
         * @param {number} id ID вопроса
         * @param {QuestionUpdateRequest} questionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion: async (id: number, questionUpdateRequest: QuestionUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateQuestion', 'id', id)
            // verify required parameter 'questionUpdateRequest' is not null or undefined
            assertParamExists('updateQuestion', 'questionUpdateRequest', questionUpdateRequest)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsApi - functional programming interface
 * @export
 */
export const QuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Создает новый вопрос для указанной вакансии
         * @summary Добавить вопрос к вакансии
         * @param {number} positionId ID вакансии
         * @param {QuestionCreateRequest} questionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPositionQuestion(positionId: number, questionCreateRequest: QuestionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Question>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPositionQuestion(positionId, questionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createPositionQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Удаляет вопрос из системы
         * @summary Удалить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestion(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.deleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает список всех вопросов в системе с пагинацией
         * @summary Получить список всех вопросов
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllQuestions(page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionsPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllQuestions(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getAllQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить детальную информацию о вопросе
         * @summary Получить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestion(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Question>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список всех вопросов для указанной вакансии
         * @summary Список вопросов по вакансии
         * @param {number} positionId ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositionQuestions(positionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPositionQuestions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositionQuestions(positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.listPositionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Регенерирует конкретный вопрос вакансии с использованием ИИ. Уровень кандидата определяет сложность и типы генерируемых вопросов. Передает в нейросеть ВСЕ поля вакансии для полного контекста. 
         * @summary Регенерировать один вопрос
         * @param {number} positionId ID вакансии
         * @param {number} questionId ID вопроса для регенерации
         * @param {QuestionRegenerateRequest} questionRegenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regeneratePositionQuestion(positionId: number, questionId: number, questionRegenerateRequest: QuestionRegenerateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Question>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regeneratePositionQuestion(positionId, questionId, questionRegenerateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.regeneratePositionQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет существующий вопрос
         * @summary Обновить вопрос
         * @param {number} id ID вопроса
         * @param {QuestionUpdateRequest} questionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestion(id: number, questionUpdateRequest: QuestionUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Question>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestion(id, questionUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionsApi - factory interface
 * @export
 */
export const QuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionsApiFp(configuration)
    return {
        /**
         * Создает новый вопрос для указанной вакансии
         * @summary Добавить вопрос к вакансии
         * @param {number} positionId ID вакансии
         * @param {QuestionCreateRequest} questionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPositionQuestion(positionId: number, questionCreateRequest: QuestionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Question> {
            return localVarFp.createPositionQuestion(positionId, questionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Удаляет вопрос из системы
         * @summary Удалить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает список всех вопросов в системе с пагинацией
         * @summary Получить список всех вопросов
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllQuestions(page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionsPaginatedResponse> {
            return localVarFp.getAllQuestions(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить детальную информацию о вопросе
         * @summary Получить вопрос по ID
         * @param {number} id ID вопроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Question> {
            return localVarFp.getQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список всех вопросов для указанной вакансии
         * @summary Список вопросов по вакансии
         * @param {number} positionId ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionQuestions(positionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListPositionQuestions200Response> {
            return localVarFp.listPositionQuestions(positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Регенерирует конкретный вопрос вакансии с использованием ИИ. Уровень кандидата определяет сложность и типы генерируемых вопросов. Передает в нейросеть ВСЕ поля вакансии для полного контекста. 
         * @summary Регенерировать один вопрос
         * @param {number} positionId ID вакансии
         * @param {number} questionId ID вопроса для регенерации
         * @param {QuestionRegenerateRequest} questionRegenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneratePositionQuestion(positionId: number, questionId: number, questionRegenerateRequest: QuestionRegenerateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Question> {
            return localVarFp.regeneratePositionQuestion(positionId, questionId, questionRegenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет существующий вопрос
         * @summary Обновить вопрос
         * @param {number} id ID вопроса
         * @param {QuestionUpdateRequest} questionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion(id: number, questionUpdateRequest: QuestionUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Question> {
            return localVarFp.updateQuestion(id, questionUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionsApi - object-oriented interface
 * @export
 * @class QuestionsApi
 * @extends {BaseAPI}
 */
export class QuestionsApi extends BaseAPI {
    /**
     * Создает новый вопрос для указанной вакансии
     * @summary Добавить вопрос к вакансии
     * @param {number} positionId ID вакансии
     * @param {QuestionCreateRequest} questionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createPositionQuestion(positionId: number, questionCreateRequest: QuestionCreateRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createPositionQuestion(positionId, questionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удаляет вопрос из системы
     * @summary Удалить вопрос по ID
     * @param {number} id ID вопроса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public deleteQuestion(id: number, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).deleteQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает список всех вопросов в системе с пагинацией
     * @summary Получить список всех вопросов
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Поле для сортировки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getAllQuestions(page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getAllQuestions(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить детальную информацию о вопросе
     * @summary Получить вопрос по ID
     * @param {number} id ID вопроса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestion(id: number, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список всех вопросов для указанной вакансии
     * @summary Список вопросов по вакансии
     * @param {number} positionId ID вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public listPositionQuestions(positionId: number, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).listPositionQuestions(positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Регенерирует конкретный вопрос вакансии с использованием ИИ. Уровень кандидата определяет сложность и типы генерируемых вопросов. Передает в нейросеть ВСЕ поля вакансии для полного контекста. 
     * @summary Регенерировать один вопрос
     * @param {number} positionId ID вакансии
     * @param {number} questionId ID вопроса для регенерации
     * @param {QuestionRegenerateRequest} questionRegenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public regeneratePositionQuestion(positionId: number, questionId: number, questionRegenerateRequest: QuestionRegenerateRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).regeneratePositionQuestion(positionId, questionId, questionRegenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет существующий вопрос
     * @summary Обновить вопрос
     * @param {number} id ID вопроса
     * @param {QuestionUpdateRequest} questionUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestion(id: number, questionUpdateRequest: QuestionUpdateRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestion(id, questionUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



